import React, { useState, useEffect } from "react";
import Navgreeting from "./Navgreeting";
import Navlink from "./Navlink";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getNumericIdFromUrl } from "../../utils/numberUtils";
import { saveEditAgentIsBrivity } from "../../store/actions/rosterActions";

/**
 * Top nav bar for the builder
 *
 * @component
 */

const Navbar = () => {
  const isAdmin = useSelector((state) => state.auth.authUser.isAdmin);
  const sessId = useSelector((state) => state.auth.authUser.sessId);
  const isBrivityAgent = useSelector((state) => state.roster.editAgentIsBrivity);

  const [showBanner, setShowBanner] = useState(false);

  const location = useLocation();
  const dispatch = useDispatch();

  const showAdminTabs = isAdmin && !sessId;

  let phpSitebuilderUrl = process.env.REACT_APP_SITEBUILDER_URL;

  useEffect(() => {
    // Check if we're on an edit agent page and set banner
    const currentPath = location.pathname;
    const isAgentPage = currentPath.startsWith('/agent/');
    const agentId = getNumericIdFromUrl(currentPath);

    setShowBanner(isAgentPage && agentId !== null);

    return () => dispatch(saveEditAgentIsBrivity(''));
  }, [location, dispatch]);

  return (
    <nav className="mainnav navbar" role="navigation" id="main-nav">
      <div className="navbar-header">
        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#main-nav-collapse">
          <span className="sr-only">Toggle Navigation</span>
        </button>
        <a className="navbar-brand" href="/">
          <img alt="logo" src="/images/realvolution-icon.png" />
        </a>
      </div>
      <div className="collapse navbar-collapse" id="main-nav-collapse">
        <ul className="nav navbar-nav">
          <Navlink title="Sites" link={`${phpSitebuilderUrl}/sites${!!sessId ? `?sessid=${sessId}` : ""}`} icon="/images/icons/monitor.svg" />
          <Navlink title="Blog" link={`${phpSitebuilderUrl}/blog${!!sessId ? `?sessid=${sessId}` : ""}`} icon="/images/icons/edit.svg" />
          <Navlink title="Images" link={`${phpSitebuilderUrl}/assets/images${!!sessId ? `?sessid=${sessId}` : ""}`} icon="/images/icons/image.svg" />
          <Navlink title="Listings" link={`${phpSitebuilderUrl}/manage-listings${!!sessId ? `/mls?sessid=${sessId}` : ""}`} icon="/images/icons/home.svg" />
          <Navlink title="Roster" link="/roster-list" icon="/images/icons/list.svg" active={true} reactRouter={true} />
          {
            showAdminTabs &&
            <>
              <Navlink title="Users" link={`${phpSitebuilderUrl}/users`} icon="/images/icons/users.svg" />
              <Navlink title="Migrate" link={`${phpSitebuilderUrl}/sites/migrate`} icon="/images/icons/arrow-up.svg" />
            </>
          }
        </ul>
        <Navgreeting />
      </div>
      {(showBanner && isBrivityAgent) && (
        <div className="roster-navbar-banner">
          These display settings are now for website roster-only agents. Please utilize the Brivity CRM for agents with a CRM seat. These settings can be found under ‘Edit User Details’ and will override changes made here for seated agents.
        </div>
      )}
    </nav>
  );
};

export default Navbar;
